import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative bg-gradient-to-br from-teal-50 to-white py-20 px-4">
      {/* 顶部广告位 */}
      <div className="max-w-6xl mx-auto mb-8">
        <div className="w-full h-24 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50">
          <span className="text-gray-400 text-sm">{t('home:ads.topBanner')}</span>
        </div>
      </div>

      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
          {t('home:hero.title')}
        </h1>
        <p className="text-xl md:text-2xl text-gray-600 mb-4">
          {t('home:hero.subtitle')}
        </p>
        <div className="flex items-center justify-center gap-4 mb-10 flex-wrap">
          <div className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full">
            <i className="ri-check-line text-xl"></i>
            <span className="font-semibold">{t('home:hero.free')}</span>
          </div>
          <div className="flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full">
            <i className="ri-user-line text-xl"></i>
            <span className="font-semibold">{t('home:hero.noRegistration')}</span>
          </div>
          <div className="flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full">
            <i className="ri-shield-check-line text-xl"></i>
            <span className="font-semibold">{t('home:hero.secure')}</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/pdf-to-word"
            className="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-word-line mr-2"></i>
            {t('home:hero.startConverting')}
          </a>
          <a
            href="#tools"
            className="w-full sm:w-auto bg-white hover:bg-gray-50 text-gray-800 px-8 py-4 rounded-lg text-lg font-semibold border-2 border-gray-300 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-tools-line mr-2"></i>
            {t('home:hero.viewAllTools')}
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-xl shadow-md">
            <div className="text-4xl font-bold text-teal-600 mb-2">10M+</div>
            <div className="text-gray-600">{t('home:hero.stats.users')}</div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md">
            <div className="text-4xl font-bold text-green-600 mb-2">50M+</div>
            <div className="text-gray-600">{t('home:hero.stats.conversions')}</div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md">
            <div className="text-4xl font-bold text-orange-500 mb-2">4.9/5</div>
            <div className="text-gray-600">{t('home:hero.stats.rating')}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
